import { render, staticRenderFns } from "./DeactivationStatus.vue?vue&type=template&id=bbbd295e&scoped=true"
import script from "./DeactivationStatus.vue?vue&type=script&lang=js"
export * from "./DeactivationStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbd295e",
  null
  
)

export default component.exports